import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  data: []
}

export const transformationSlice = createSlice({
  name: 'transformation',
  initialState,
  reducers: {
    loadTransformationSate: (state, action) => {
      state.loading = action.payload
    },
    setTransformation: (state, action) => {
      state.data = action.payload
    },
  },
})

//
export const { loadTransformationSate, setTransformation } = transformationSlice.actions

export default transformationSlice.reducer